export default {
    lang: {
        name: 'Avg. play value'
    }
}